import { render, staticRenderFns } from "./chatarchive.vue?vue&type=template&id=253e5888"
import script from "./chatarchive.vue?vue&type=script&lang=js"
export * from "./chatarchive.vue?vue&type=script&lang=js"
import style0 from "./chatarchive.vue?vue&type=style&index=0&id=253e5888&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports